// Replaces js/src/ajax.js. fetch() instead of $.ajax(), returns a Promise.

/**
 * Fetch the sales rep list for a given zip code.
 *
 * @param {string} apiUrl   - API endpoint (typically https://api.essilorusa.com/sales/)
 * @param {string} apiKey   - API key
 * @param {string} zipcode  - 5-digit zip code (already validated)
 * @returns {Promise<Array<{name:string,phone1:string,phone2:string,email:string}>>}
 */
export async function getList(apiUrl, apiKey, zipcode) {
  const url = new URL(apiUrl);
  url.searchParams.set('zipcode', zipcode);
  url.searchParams.set('key', apiKey);

  const res = await fetch(url.toString(), {
    method: 'GET',
    credentials: 'omit',
    headers: { Accept: 'application/json' },
  });

  if (!res.ok) {
    const err = new Error(`API error: ${res.status}`);
    err.status = res.status;
    throw err;
  }

  // The API returns a JSON array directly.
  return res.json();
}
